import dashboardTypes from './dashboard.types';

export const fetchDashboardStart = () => ({
  type: dashboardTypes.FETCH_DASHBOARD_START,
});

export const fetchDashboardChartStart = () => ({
  type: dashboardTypes.FETCH_DASHBOARD_CHART_START,
});

export const setLoadingDashboard = (payload) => ({
  type: dashboardTypes.SET_LOADING_DASHBOARD,
  payload,
});

export const setDashboardData = (payload) => ({
  type: dashboardTypes.SET_DASHBOARD_DATA,
  payload,
});

export const setLoadingDashboardChart = (payload) => ({
  type: dashboardTypes.SET_LOADING_DASHBOARD_CHART,
  payload,
});

export const setDashboardChartData = (payload) => ({
  type: dashboardTypes.SET_DASHBOARD_CHART_DATA,
  payload,
});
